import React from "react";
import newImg from "../../assets/images/common/new_img.png";
import playButton from "../../assets/images/playButtonImg.png";
import { handleImageErrorCallBack } from "./ErrorImage_PlaceHolder";
interface VideoImageOverlayProps {
  videoUrl: string;
  newFlag: boolean;
  width: string;
  height: string;
  playBtnwidth: string;
  playBtnheight: string;
  onClick?: () => void;
}

const VideoImageOverlay: React.FC<VideoImageOverlayProps> = ({
  videoUrl,
  newFlag,
  width,
  height,
  playBtnwidth,
  playBtnheight,
  onClick,
}) => {
  return (
    <div style={{ position: "relative" }}>
      <img
        src={videoUrl}
        alt=""
        style={{
          width: width,
          height: height,
          cursor: onClick ? "pointer" : "default",
        }}
        onClick={onClick}
        onError={(e) => handleImageErrorCallBack(e, width, height, onClick)}
      />
      <img
        src={playButton}
        alt="Overlay"
        style={{
          position: "absolute",
          cursor: "pointer",
          top: "50%",
          left: "50%",
          width: playBtnwidth,
          height: playBtnheight,
          transform: "translate(-50%, -50%)", // Center the image
        }}
        onClick={onClick}
      />
      {newFlag && (
        <img
          src={newImg}
          alt="Overlay"
          style={{
            position: "absolute",
            top: "8px", // Adjust to position
            left: "8px", // Adjust to position
            width: "30px",
            height: "20px",
          }}
        />
      )}
    </div>
  );
};

export default VideoImageOverlay;
